import { render, staticRenderFns } from "./PayPalCancel.vue?vue&type=template&id=27d38b6c"
import script from "./PayPalCancel.vue?vue&type=script&lang=js"
export * from "./PayPalCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports